import React from 'react';
import { Shield, FileText, Mail, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function Rights() {
  return <div className="min-h-screen bg-[#0a0a0a]" data-id="element-566">
      {/* Hero Section */}
      <div className="relative bg-[#050505] py-20 border-b border-[#222]" data-id="element-567">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-[1px] bg-gradient-to-r from-transparent via-[#D22B2B] to-transparent opacity-50" data-id="element-568"></div>

        <div className="container mx-auto px-4" data-id="element-569">
          <div className="max-w-4xl mx-auto text-center" data-id="element-570">
            <div className="inline-flex items-center gap-2 mb-6 px-4 py-1.5 border border-[#333] bg-black/50 backdrop-blur-md rounded-full" data-id="element-571">
              <Shield className="w-3 h-3 text-[#D22B2B]" data-id="element-572" />
              <span className="font-serif uppercase tracking-[0.3em] text-[10px] text-gray-400" data-id="element-573">
                Правообладателям
              </span>
            </div>

            <h1 className="font-noir text-5xl md:text-7xl font-medium text-white mb-6 tracking-tight" data-id="element-574">
              Защита авторских <br data-id="element-575" />
              <span className="text-[#D22B2B]" data-id="element-576">прав</span>
            </h1>

            <p className="text-lg text-gray-400 font-serif font-light leading-relaxed" data-id="element-577">
              Мы уважаем права создателей и правообладателей контента
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-16" data-id="element-578">
        <div className="max-w-4xl mx-auto space-y-16" data-id="element-579">
          {/* Policy Section */}
          <section className="bg-[#141414] p-8 md:p-12 border-l-2 border-[#D22B2B] relative shadow-2xl" data-id="element-580">
            <div className="flex items-start gap-6 mb-6" data-id="element-581">
              <div className="p-3 bg-[#D22B2B]/10 text-[#D22B2B] border border-[#D22B2B]/30 rounded-full shadow-[0_0_15px_rgba(210,43,43,0.2)]" data-id="element-582">
                <Shield className="w-6 h-6" data-id="element-583" />
              </div>
              <div data-id="element-584">
                <h2 className="font-noir text-3xl text-white mb-4 tracking-wide" data-id="element-585">
                  Наша политика
                </h2>
                <p className="text-gray-300 font-serif leading-relaxed mb-4" data-id="element-586">
                  KINOSOVETY уважает права интеллектуальной собственности и
                  стремится соблюдать законодательство Российской Федерации в
                  области авторского права. Мы работаем только с контентом,
                  который находится в общественном достоянии, или получили
                  соответствующие разрешения от правообладателей.
                </p>
                <p className="text-gray-300 font-serif leading-relaxed" data-id="element-587">
                  Если вы являетесь правообладателем и считаете, что ваши права
                  нарушены, мы готовы оперативно рассмотреть ваше обращение и
                  принять необходимые меры.
                </p>
              </div>
            </div>
          </section>

          {/* Notice Section */}
          <section data-id="element-588">
            <h2 className="font-noir text-3xl text-white mb-8 tracking-wide" data-id="element-589">
              Подача уведомления о нарушении
            </h2>

            <div className="bg-[#141414] p-8 border border-[#333] mb-8" data-id="element-590">
              <div className="flex items-start gap-4 mb-6" data-id="element-591">
                <div className="p-2 bg-[#D22B2B]/10 text-[#D22B2B] border border-[#D22B2B]/30 rounded-full shrink-0" data-id="element-592">
                  <AlertCircle className="w-5 h-5" data-id="element-593" />
                </div>
                <div data-id="element-594">
                  <h3 className="font-serif text-lg text-white mb-3" data-id="element-595">
                    Требования к уведомлению
                  </h3>
                  <p className="text-gray-400 font-serif text-sm leading-relaxed mb-4" data-id="element-596">
                    Для рассмотрения вашего обращения, пожалуйста, предоставьте
                    следующую информацию:
                  </p>
                </div>
              </div>

              <div className="space-y-4 ml-14" data-id="element-597">
                <div className="flex items-start gap-3" data-id="element-598">
                  <div className="w-2 h-2 bg-[#D22B2B] rounded-full mt-2 shrink-0" data-id="element-599"></div>
                  <p className="text-gray-300 font-serif text-sm" data-id="element-600">
                    <strong className="text-white" data-id="element-601">
                      Идентификация произведения:
                    </strong>{' '}
                    Точное название фильма, год выпуска, киностудия
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-602">
                  <div className="w-2 h-2 bg-[#D22B2B] rounded-full mt-2 shrink-0" data-id="element-603"></div>
                  <p className="text-gray-300 font-serif text-sm" data-id="element-604">
                    <strong className="text-white" data-id="element-605">Доказательство прав:</strong>{' '}
                    Документы, подтверждающие ваши права на произведение
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-606">
                  <div className="w-2 h-2 bg-[#D22B2B] rounded-full mt-2 shrink-0" data-id="element-607"></div>
                  <p className="text-gray-300 font-serif text-sm" data-id="element-608">
                    <strong className="text-white" data-id="element-609">
                      Контактная информация:
                    </strong>{' '}
                    ФИО, адрес электронной почты, телефон
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-610">
                  <div className="w-2 h-2 bg-[#D22B2B] rounded-full mt-2 shrink-0" data-id="element-611"></div>
                  <p className="text-gray-300 font-serif text-sm" data-id="element-612">
                    <strong className="text-white" data-id="element-613">Описание нарушения:</strong>{' '}
                    Ссылка на страницу с контентом и описание нарушения
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-614">
                  <div className="w-2 h-2 bg-[#D22B2B] rounded-full mt-2 shrink-0" data-id="element-615"></div>
                  <p className="text-gray-300 font-serif text-sm" data-id="element-616">
                    <strong className="text-white" data-id="element-617">Подпись:</strong> Электронная
                    или физическая подпись правообладателя или уполномоченного
                    лица
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-[#141414] p-6 border border-[#333]" data-id="element-618">
              <div className="flex items-start gap-4" data-id="element-619">
                <div className="p-2 bg-[#D22B2B]/10 text-[#D22B2B] border border-[#D22B2B]/30 rounded-full shrink-0" data-id="element-620">
                  <FileText className="w-5 h-5" data-id="element-621" />
                </div>
                <div className="flex-1" data-id="element-622">
                  <h3 className="font-serif text-lg text-white mb-3" data-id="element-623">
                    Сроки рассмотрения
                  </h3>
                  <p className="text-gray-400 font-serif text-sm leading-relaxed" data-id="element-624">
                    Мы обязуемся рассмотреть ваше обращение в течение 3 рабочих
                    дней с момента получения полного пакета документов. В случае
                    подтверждения нарушения, контент будет удален в течение 24
                    часов.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Contact Section */}
          <section className="bg-[#141414] p-8 md:p-12 border border-[#333]" data-id="element-625">
            <div className="text-center" data-id="element-626">
              <div className="inline-flex p-4 bg-[#D22B2B]/10 text-[#D22B2B] border border-[#D22B2B]/30 rounded-full shadow-[0_0_15px_rgba(210,43,43,0.2)] mb-6" data-id="element-627">
                <Mail className="w-8 h-8" data-id="element-628" />
              </div>

              <h2 className="font-noir text-3xl text-white mb-4 tracking-wide" data-id="element-629">
                Контакты для правообладателей
              </h2>

              <p className="text-gray-400 font-serif mb-6 max-w-2xl mx-auto" data-id="element-630">
                Направляйте все обращения, связанные с защитой авторских прав,
                на специальный адрес электронной почты:
              </p>

              <a href="mailto:copyright@kinosovety.ru" className="inline-block text-xl text-[#D22B2B] hover:text-white transition-colors font-serif mb-8" data-id="element-631">
                copyright@kinosovety.ru
              </a>

              <div className="border-t border-[#222] pt-6" data-id="element-632">
                <p className="text-xs text-gray-500 font-serif" data-id="element-633">
                  Пожалуйста, используйте этот адрес только для вопросов,
                  связанных с авторскими правами. <br data-id="element-634" />
                  Для общих вопросов используйте{' '}
                  <a href="mailto:info@kinosovety.ru" className="text-[#D22B2B] hover:text-white transition-colors" data-id="element-635">
                    info@kinosovety.ru
                  </a>
                </p>
              </div>
            </div>
          </section>

          {/* Additional Info */}
          <section className="border-t border-[#222] pt-12" data-id="element-636">
            <h2 className="font-noir text-3xl text-white mb-8 tracking-wide" data-id="element-637">
              Дополнительная информация
            </h2>

            <div className="space-y-6 text-gray-300 font-serif leading-relaxed" data-id="element-638">
              <p data-id="element-639">
                KINOSOVETY признает важность защиты интеллектуальной
                собственности и активно сотрудничает с правообладателями для
                обеспечения законного использования контента. Мы регулярно
                проверяем наш каталог на соответствие требованиям
                законодательства.
              </p>
              <p data-id="element-640">
                Если вы являетесь правообладателем и заинтересованы в легальном
                размещении вашего контента на нашей платформе, мы открыты для
                сотрудничества. Свяжитесь с нами для обсуждения условий
                партнерства.
              </p>
              <div className="bg-[#141414] p-6 border-l-2 border-[#D22B2B]" data-id="element-641">
                <p className="text-sm text-gray-400 italic" data-id="element-642">
                  Обратите внимание: ложные заявления о нарушении авторских прав
                  могут повлечь за собой юридическую ответственность. Убедитесь,
                  что вы являетесь правообладателем или уполномоченным
                  представителем перед подачей уведомления.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>;
}